import React from 'react';
import Dialog from '../../Atoms/Modal/Dialog';
import { DialogProps } from '../../Atoms/Modal/Dialog/Dialog';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { IAnyPanel } from '../Dashboard.model';
import { useTranslation } from 'react-i18next';

interface DashboardAddPanelModalProps extends Omit<DialogProps, 'children'> {
  onSavePanel: (panelId: string) => void;
  availablePanels: IAnyPanel[];
}
function DashboardAddPanelModal(props: DashboardAddPanelModalProps) {
  const [selectedPanelId, setSelectedPanelId] = React.useState<string>('');
  const { onSavePanel, availablePanels } = props;
  const { t } = useTranslation();

  // rest value on open or close
  React.useEffect(() => {
    if (props.open) {
      setSelectedPanelId('');
    }
  }, [props.open]);

  const handlePanelSelect = (event: { target: { value: string } }) => {
    const panelId = event.target.value;
    setSelectedPanelId(panelId);
  };

  return (
    <Dialog
      title={t('dashboard.select_panel', 'Select Panel') || 'Select Panel'}
      onSave={() => onSavePanel(selectedPanelId)}
      maxWidth="sm"
      fullWidth
      {...props}
    >
      <FormControl fullWidth>
        <InputLabel id="select-panel-label">
          {t('dashboard.panel', 'Panel') || 'Panel'}
        </InputLabel>
        <Select
          labelId="select-panel-label"
          value={selectedPanelId}
          label={t('dashboard.panel', 'Panel') || 'Panel'}
          onChange={handlePanelSelect}
        >
          {availablePanels.map((panel) => (
            <MenuItem key={panel.id} value={panel.id}>
              {panel.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Dialog>
  );
}

export default DashboardAddPanelModal;
